import React from 'react'
import HintButton from '../../pageBaseComponents/HintButton'
import {FullWidthLeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'

interface ExternalProps {
    hint?: string
}

export interface HintProps {
    hint?: string
}

export const withHint = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & HintProps>,
) => {

    type ResultProps = OriginalProps & ExternalProps;

    const WithHint = (props: ResultProps) => {
        return (<>
            <FullWidthLeftRowFlexContainer>
                <WrappedComponent {...props}/>
                {
                    props.hint && props.hint.length > 0 &&
                    <HintButton message={props.hint}/>
                }
            </FullWidthLeftRowFlexContainer>
        </>)
    }
    WithHint.displayName = `WithHint(${WrappedComponent.displayName})`
    return WithHint
}
